// export const API_URL = "http://67.4.212.216:8001";

export let API_URL = process.env.NODE_ENV === 'development' ?
    //'http://localhost:8787/'
    'https://api.rotate.group/'
    : 'https://api.rotate.group/'

export const SSO_URL = 'https://sso.rotate.group/';

export const CARRIER_ID = "1066f579-a0f1-41c1-a581-e188c7cdfb77";
